import React from 'react'
import SettingsSuggest from '@mui/icons-material/SettingsSuggest'
import useCustomColumnsModal from 'utils/hooks/useCustomColumnsModal'
import { Tooltip, Button } from '@mui/material'
import { relative } from 'path'

const CustomizeColumnsButton = () => {
  const { setOpenModal, CustomColumnsModal } = useCustomColumnsModal()
  const handleClick = () => {
    setOpenModal(true)
  }
  return (
    <>
      <Tooltip
        title="Personnaliser..."
        followCursor
      >
        <Button
          onClick={handleClick}
          sx={{ color: 'white' }}
          className="flex items-center justify-center h-full"
        >
          <SettingsSuggest className="mb-1" />
        </Button>
      </Tooltip>
      <CustomColumnsModal />
    </>
  )
}

export default CustomizeColumnsButton
